<template>
  <v-container>
    <PageHeader :title="name" />

    <v-form ref="form" style="width: 100%">
      <v-card>
        <Subheader title="Station Graph Visiblity" no-search></Subheader>
        <v-progress-linear v-if="isLoading" :indeterminate="true"></v-progress-linear>
        <v-card-text>
          <v-layout row wrap v-if="!isLoading">
            <v-flex xs12 md10 offset-md1>
              <v-layout row wrap align-center>
                <v-flex xs8>Toggle Graph Tab Visibility</v-flex>
                <v-flex xs4>
                  <v-checkbox v-model="graphTabIsVisibleForm" @change="handleToggleGraphVisibility">
                    <template v-slot:label>
                      <div v-if="graphVisibilityToggleIsLoading">
                        <v-progress-circular :indeterminate="graphVisibilityToggleIsLoading"></v-progress-circular>
                      </div>
                    </template>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>

    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { UiConfigKeys } from '@/store/UI/uiconfig'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import ErrorDialog from '@/components/generic/ErrorDialog'

  const uiConfig = createNamespacedHelpers('uiconfig')

  export default {
    components: {
      ErrorDialog,
    },
    mixins: [SnackBarUtil],
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        isLoading: false,
        graphVisibilityToggleIsLoading: false,
        graphTabIsVisibleForm: false,
        tenantUiConfigOptions: [],
      }
    },
    computed: {
      ...uiConfig.mapGetters(['uiConfigOptions']),
      graphTabIsVisible() {
        let graphVisibilityOption = this.tenantUiConfigOptions.find(
          opt => opt.Key === UiConfigKeys.StationGraphTabGlobalVisibility
        )
        if (!(graphVisibilityOption && graphVisibilityOption.Value)) {
          return false
        }
        return JSON.parse(graphVisibilityOption.Value)
      },
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    watch: {
      graphTabIsVisible() {
        this.graphTabIsVisibleForm = this.graphTabIsVisible
      },
    },
    methods: {
      ...uiConfig.mapActions([
        'getUiConfigOptions',
        'putUiConfigOptionArray',
      ]),
      handleToggleGraphVisibility() {
        let data = [{
          Key: UiConfigKeys.StationGraphTabGlobalVisibility,
          Value: this.graphTabIsVisibleForm,
        }]
        this.putUiConfigOptions(data)
      },
      fetchUiConfigOptions() {
        let that = this
        let options = {
          config: {
            params: {
              tenant: that.name,
            },
          },
          successCb(data) {
            that.tenantUiConfigOptions = data
            that.isLoading = false
          },
          failedCb: (msg) => {
            console.error(msg)
            that.isLoading = false
            this.$store.dispatch('app/setErrorDialog', {
              data: `Failed to fetch options: ${msg}`,
              title: '',
              show: true,
            })
          },
        }
        this.isLoading = true
        this.getUiConfigOptions(options)
      },

      putUiConfigOptions(configOptions) {
        let that = this
        let options = {
          data: configOptions,
          update: true,
          config: {
            params: {
              tenant: that.name,
            },
          },
          successCb() {
            that.graphVisibilityToggleIsLoading = false
            that.handleNotification({
              type: 'success',
              message: 'Successfully updated configurations',
            })
          },
          failedCb: (msg) => {
            console.error(msg)
            that.graphVisibilityToggleIsLoading = false
            this.$store.dispatch('app/setErrorDialog', {
              data: `Failed to update configurations: ${msg}`,
              title: '',
              show: true,
            })
          },
        }
        this.graphVisibilityToggleIsLoading = true
        this.putUiConfigOptionArray(options)
      },
    },
    mounted() {
      this.fetchUiConfigOptions()
    },
  }
</script>

<style scoped lang="stylus"></style>